// Timestamps from the backend are UTC, but written WITHOUT a timezone marker:
//
//     "2026-09-17 10:33:00"
//
// Passed straight to new Date(), JavaScript reads that as LOCAL time. In IST
// that makes every stored time look 5h30m older than it really is - a run from
// a minute ago showed as "5 hours ago" on the dashboard.
//
// Mark it as UTC before parsing. A value that already carries a timezone (or is
// already a Date) is left alone.
export function normalizeDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

  const hasTimezone = typeof value === 'string' && /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);
  const parsed = new Date(hasTimezone ? value : String(value).replace(' ', 'T') + 'Z');
  return isNaN(parsed.getTime()) ? null : parsed;
}

// "Just now" / "5 mins ago" / "2 hours ago" / "3 days ago"
export function timeAgo(value, fallback = 'N/A') {
  const date = normalizeDate(value);
  if (!date) return fallback;

  const diffMs = Date.now() - date.getTime();
  const mins = Math.floor(diffMs / 60000);
  const hours = Math.floor(diffMs / 3600000);
  const days = Math.floor(diffMs / 86400000);

  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins} ${mins === 1 ? 'min' : 'mins'} ago`;
  if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  return `${days} ${days === 1 ? 'day' : 'days'} ago`;
}
